import Debug from './_debug';
import $ from 'jquery';

let Animation = {};  

Animation.initialize = () => {
  Debug.log('Animation: initialize');
  Animation.animateMenu();
  Animation.animateHomeRespiFILText();
  Animation.animateHomeIllustration();
}

Animation.animateMenu = () =>  {
  window.setTimeout(_ => {
    $('.row-logo').addClass('animate');
  }, 300);
  window.setTimeout(_ => {
    $('.row-logo').addClass('animate');
    $('.menu').addClass('animate'); 
  }, 600);  
}

Animation.animateHomeRespiFILText = () =>  {
  window.setTimeout(_ => {
    $('.home-custom-bg-title').addClass('animate');
  }, 600); 
}

Animation.animateHomeIllustration = () =>  {
  window.setTimeout(_ => {
    $('.drawing').addClass('animate');
    $('.drawing-mobile').addClass('animate');
  }, 600); 
}



export default Animation;